import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
import { ICONS } from 'src/utils/icons';
import { TranslatorFunction } from 'src/locales/use-locales';

// ----------------------------------------------------------------------

const FULL_MENU = (t: TranslatorFunction) => [
  // OVERVIEW
  // ----------------------------------------------------------------------
  {
    subheader: t('navmenu.overview'),
    items: [
      {
        title: t('navmenu.dashboard'),
        path: paths.dashboard.root,
        icon: ICONS.dashboard,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: t('navmenu.management'),
    items: [
      {
        title: t('navmenu.instruments'),
        path: paths.dashboard.instruments.root,
        icon: ICONS.reports,
      },
      {
        title: t('navmenu.measurements'),
        path: paths.dashboard.measurements.root,
        icon: ICONS.analytics,
      },
      {
        title: t('navmenu.yards'),
        path: paths.dashboard.yards.root,
        icon: ICONS.users,
      },
      {
        title: t('navmenu.certifications'),
        path: paths.dashboard.certifications.root,
        icon: ICONS.award,
      },
      {
        title: t('navmenu.collaudi'),
        path: paths.dashboard.collaudi.root,
        icon: ICONS.reports,
      },
      {
        title: t('navmenu.logs'),
        path: paths.dashboard.logs.root,
        icon: ICONS.analytics,
      },
      {
        title: t('navmenu.configuration'),
        path: paths.dashboard.configuration.root,
        icon: ICONS.settings,
      },
      {
        title: t('navmenu.users'),
        path: paths.dashboard.users.root,
        icon: ICONS.users,
      },
    ],
  },
];

export function useNavData() {
  const { t } = useLocales();

  return useMemo(() => FULL_MENU(t), [t]);
}
